<template>
	<div class="shenhe2">
        <el-card>
            <span>状态： </span>
            <el-select v-model="zhuangtai2" placeholder="请选择" clearable style="width:100px" >
                <el-option label="待审核" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="拒绝" value="2"></el-option>
            </el-select>

            <span>司机： </span>
            <el-input v-model="siji" placeholder="请输入司机姓名" clearable ></el-input>

            <el-button type="success" icon="el-icon-search" @click="getInfo()">查询</el-button>
            <el-button type="info" icon="el-icon-download" @click="exportTable">导出表格</el-button>

            <el-table
                :data="userData"
                stripe
                border
                id="history-table"
                style="width: 100%;margin-top:20px">
                <el-table-column
                    prop="create_time"
                    label="时间"
                    width='200'>
                </el-table-column>
               
                <el-table-column
                    prop="tel"
                    label="登录手机">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="password"
                    label="登录密码">
                </el-table-column>

                <el-table-column prop="beizhu" label="备注">
                    <template slot-scope="scope">
                        <p>{{scope.row.beizhu}}</p>
                    </template>
                </el-table-column>

                <el-table-column label="修改" >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="edit(scope.row.id)">修改备注</el-button>
                    </template>
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status==0">待审核</p>
                        <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                        <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                    </template>
                </el-table-column>

                <el-table-column label="审核" width="140">
                    <template slot-scope="scope">
                        <!-- <div v-if="scope.row.status!=1"> -->
                            <el-button type="text" @click="caoZuo2(scope.row.id,1)">通过</el-button>
                            <el-button type="text" style="color:#F56C6C;font-weight:600" @click="caoZuo2(scope.row.id,2)">拒绝</el-button>
                            <el-button type="text" style="color:#909399" @click="caoZuo2(scope.row.id,3)">删除</el-button>
                        <!-- </div> -->
                    </template>
                </el-table-column>

                <el-table-column label="审核人">
                    <template slot-scope="scope">
                        <p>管理员</p>
                    </template>
                </el-table-column>

            </el-table>
        </el-card>
    </div>
</template>

<script>
    import { url2 } from '../router/api';
	export default{
		data(){
			return{
                zhuangtai2:'',
                userData:[],
                siji:'',
            }
        },
        async mounted() {
            await this.getInfo()
        },
      
		methods: {

            edit(x) {
                this.$prompt('请输入备注', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.axios.get(url2+'edit3', {
                        params:{
                            id:x,
                            value:value
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.getInfo()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            },

            exportTable() {
                //导出名称
                let excelName = "历史数据" + new Date().getTime() + ".xlsx";
                const xlsxParam = { raw: true }; //转化成Excel使用原始格式
                const table_book = this.$XLSX.utils.table_to_book(
                    document.querySelector("#history-table"),
                    xlsxParam
                );
                const table_write = this.$XLSX.write(table_book, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array",
                });
                try {
                    this.$FileSaver.saveAs(
                    new Blob([table_write], { type: "application/octet-stream" }),
                    excelName
                    );
                } catch (e) {
                    if (typeof console !== "undefined") console.log(e, table_write);
                }
                return table_write;
            },
           
            caoZuo2(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2+'caoZuo3', {
                        params:{
                            id:x,
                            id_status:y,
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.getInfo()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
               
            },

            async getInfo() {
                await this.axios.get(url2+'searchInfo2', {
                    params:{
                        siji:this.siji,
                        zhuangtai:this.zhuangtai2,
                    }
                }).then(res=> {
                    this.userData = res.data.data
                }).catch(err=> {
                    console.log(err);
                });
            },
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .shenhe2 {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .shenhe2 .el-input {
        width:140px;
        margin-right: 20px;
    }

    .shenhe2 .el-select {
        width:140px;
        margin-right: 20px;
    }
    .shenhe2 main {
       margin-bottom: 20px;
    }
    
</style>